module.exports = __webpack_public_path__ + "img/tor_1.8dcd9a74.webp";